module.exports = __webpack_public_path__ + "static/media/dataDownloadIT.8c9db3d0.md";